import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-why-inforida',
  templateUrl: './why-inforida.component.html',
  styleUrls: ['./why-inforida.component.scss'],
  standalone: false,
  // imports: [SharedModule],
})
export class WhyInforidaComponent {
  fourPillars = [
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image1.png',
      heading: 'People',
      description:
        'Boost staff productivity with efficient tools and secure, role-based access.',
      number: '01',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image2.png',
      heading: 'Finance',
      description:
        'Manage finances, fee collection, and reports effortlessly in one place.',
      number: '02',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image3.png',
      heading: 'Classroom',
      description:
        'Simplify operations and improve learning with smart classroom tools.',
      number: '03',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/pillar-image4.png',
      heading: 'Communication',
      description:
        'Keep staff and parents connected with real-time, transparent communication.',
      number: '04',
    },
  ];

  quickEnrollPoints = [
    {
      icon: '🔵',
      description:
        'Showcase your school’s <b>facilities, infrastructure, achievements</b>. Easily Display <b>Events</b> & <b>Announcements</b> with customisable banners ',
      buttonText: 'Learn how we can do it for you',
      buttonColor: 'blue',
    },
    {
      icon: '🔺',
      description:
        'Edit the public page in <b>Real-time</b> with millions of <b>Colours & themes</b>',
      buttonText: 'Learn how we can do it for you',
      buttonColor: 'green',
    },
    {
      icon: '🟡',
      description:
        'Effortlessly <b>Create</b> a <b>Government-compliant public page</b> improving your digital presence ',
      buttonText: 'Learn how we can do it for you',
      buttonColor: 'yellow',
    },
  ];

  attendancePoints = [
    {
      icon: '🔵',
      description: 'Say Goodbye to Attendance Registers & Save Paper',
      buttonText: 'Learn how we can do it for you',
      buttonColor: 'blue',
      textColor: 'white',
    },
    {
      icon: '🔺',
      description: 'Save time on attendance & Spend Where It Matters',
      buttonText: 'Learn how we can do it for you',
      buttonColor: 'green',
      textColor: 'white',
    },
    {
      icon: '🟡',
      description: 'Protect Your Data with Secure Biometric Technology',
      buttonText: 'Learn how we can do it for you',
      buttonColor: 'yellow',
      textColor: 'black',
    },
  ];

  description = [
    'Effortlessly <b> Create</b> A <b>Government-compliant public page</b> improving your digital presence ',
    'Showcase your school’s <b>Facilities</b>, <b>Infrastructure</b>, <b>achievements</b>. Easily Display events & Announcements with customisable banners ',
    'Edit the public page in <b>Real-Time</b> with millions of <b>Colours & Themes</b>',
  ];

  goodmorningDescription = [
    'Say goodbye to <b> Attendance Registers</b> & <b>Save Paper</b>',
    '<b>Save Time</b> On Attendance & spend where it Matters',
    'Protect your data with <b>Secure Biometric</b> Technology',
  ];

  benifits = [
    {
      icon: 'school',
      backgroundColor: 'rgba(221, 246, 230, 1)',
      title: 'Designed & Built for Schools in Mind',
      description:
        "Perfectly suited for your school's administration & operational needs.",
    },
    {
      icon: 'language',
      backgroundColor: 'rgba(216, 231, 255, 1)',
      title: 'Multi language support',
      description:
        'Engage seamlessly in the language that works best for you and your team.',
    },
    {
      icon: 'attach_money',
      backgroundColor: 'rgba(253, 246, 222, 1)',
      title: 'Flexible pricing (Pay as you go)',
      description: 'Only pay for what you need - a plan that grows with you.',
    },
    {
      icon: 'rocket_launch',
      backgroundColor: 'rgba(255, 213, 202, 1)',
      title: 'Activate in just 10 min',
      description:
        "Quick setup means you're ready to go in no time - hassle-free!",
    },
  ];
}
